module.exports = __webpack_public_path__ + "static/media/bg2.61a6ab79.jpg";